/**
 * The kind of contact phone number (cell, home, office, fax).  Names and values match the monolith master <c>Hireahelper.Core.Model.Contact.PhoneType</c>.  Not the Twilio line classification (landline/mobile/VoIP), which is a different concept.
 */
export enum PhoneType {
    Unknown = 0,
    Cell = 100,
    Home = 110,
    Office = 120,
    Fax = 130,
}

const phoneTypeDescription = {
    Unknown: 'Unknown',
    Cell: 'Cell',
    Home: 'Home',
    Office: 'Office',
    Fax: 'Fax',
};

export const PhoneTypeDescription = {
    ...phoneTypeDescription,

    get: (value: PhoneType | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return phoneTypeDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return phoneTypeDescription[PhoneType[value]  as keyof typeof phoneTypeDescription];
    },
    all: [
        { value: 0, label: phoneTypeDescription.Unknown },
        { value: 100, label: phoneTypeDescription.Cell },
        { value: 110, label: phoneTypeDescription.Home },
        { value: 120, label: phoneTypeDescription.Office },
        { value: 130, label: phoneTypeDescription.Fax },
    ] as ReadonlyArray<{label: string, value: number}>
};
